// extracted by mini-css-extract-plugin
module.exports = {"Issue__root":"LkJJ","Issue__img":"CZXZ","Issue__content":"_9oBx","Issue__name":"Qp61","Issue__info":"rian","Issue__txt":"dB72","Issue__btn":"_aaQ"};